<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    @closed="$emit('closed')"
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <template v-if="!successMessage">
      <div class="ml-1 mb-2">
        <a v-if="fileTemplateUrl" :href="fileTemplateUrl" target="_blank">
          <u>Скачать Шаблон файла</u>
        </a>
      </div>
      <BFileUpload
        :value="file"
        :upload-file="uploadFile"
        :error-message="errorMessage"
      />
    </template>

    <div v-if="successMessage" v-html="successMessage" />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />

    <div class="pt-5 font-italic">
      <p>
        Столбец login должен содержать логин пользователя, которого надо
        добавить в список или удалить из него.
      </p>
      <p>
        Столбец members должен содержать название Участника, в которого мы
        добавляем пользователя из первого столбца.
      </p>
      <p>
        Столбец members_exclude должен содержать название Участника, из которого
        мы удаляем пользователя из первого столбца.
      </p>
    </div>
  </BModalConfirm>
</template>

<script>
import { ParticipantsApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BFileUpload from '@/components/forms/BFileUpload.vue'

export const SUCCESS_MESSAGE = 'Файл будет обработан в фоновом режиме. Статус его обработки будет получен в уведомлениях системы.'

export default {
  name: 'BAteTreeParticipantsImportModal',
  components: {
    BModalConfirm,
    BFileUpload,
  },
  titleText: 'Импорт участников',
  inheritAttrs: false,
  props: {
    participant_id: Number,
  },
  data: () => ({
    isLoading: false,
    successMessage: null,
    errorMessage: null,
    file: null,
    fileTemplateUrl: '/files/participants_import.xlsx',
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
    async uploadFile(file) {
      this.errorMessage = null
      this.isLoading = true

      const api = new ParticipantsApi()
      try {
        await api.import(file)
        this.successMessage = SUCCESS_MESSAGE
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
